import {
  TableRow,
  TableCell,
  Table,
  TableHead,
  TableBody,
  TableContainer,
  Paper,
  Accordion,
  Grid,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton,
} from '@material-ui/core';
import React, { useState } from 'react';
import {
  serviceCategoriesEnum,
  serviceCategoryTotalRows,
  simulationRows,
} from './helpers';

import { DetailTableProps, ISimulationEPS } from './interfaces';
import Row from './Row';
import { createTableCellLabels } from './TableCell/TableCellLabels';
import { createTableCellValues } from './TableCell/TableCellValues';
import { useStyles } from './styles';
import { KeyboardArrowUp, KeyboardArrowDown } from '@material-ui/icons';

const DetailTable: React.FC<DetailTableProps> = ({
  serviceCategories,
  serviceCategoriesTotal,
  isSimulation = false,
}) => {
  const classes = useStyles();

  const [accordionShow, setAccordionShow] = useState<{
    [key: string]: boolean;
  }>({});
  const serviceCategoriesKeys = Object.keys(serviceCategories);

  const toggleAccordion = (accordionKey: string) => {
    setAccordionShow((prev) => ({
      ...prev,
      [accordionKey]: !prev[accordionKey],
    }));
  };

  return (
    <Grid container direction="column" alignItems="stretch">
      {serviceCategoriesKeys.map((key, index) => {
        const rows = Object.entries(serviceCategories[key]).map(
          ([mailingRuleId, mailing]) => ({
            id: mailingRuleId,
            name: mailing.rule,
            totalCustomer: mailing.totalCustomer,
            totalContract: mailing.totalContract,
            totalCurrentTotalValue: mailing.totalCurrentTotalValue,
            debtsDistribution: mailing.debtsDistribution,
            EPSs: Object.entries(mailing.distribution).map(([epsId, eps]) => {
              const simulationEPS = eps as ISimulationEPS;
              return {
                id: epsId,
                name: simulationEPS.eps,
                percentual: simulationEPS.percentual,
                total: simulationEPS.total,
                totalCustomer: simulationEPS.totalCustomer,
                totalContract: simulationEPS.totalContract,
                totalCurrentTotalValue: simulationEPS.totalCurrentTotalValue,
              };
            }),
          }),
        );

        return (
          <Accordion
            key={`${key}_${index}`}
            expanded={true}
            onChange={() => {
              toggleAccordion(key);
            }}
          >
            <AccordionSummary className={classes.summaryContainer}>
              <Grid container direction="row" className={classes.summaryGrid}>
                <Grid
                  item
                  container
                  direction="column"
                  xs={4}
                  alignItems="flex-start"
                  justifyContent="space-evenly"
                >
                  <Typography>{serviceCategoriesEnum[key]}</Typography>
                  <IconButton
                    className={classes.summaryIconButton}
                    size="small"
                  >
                    {accordionShow[key] ? (
                      <KeyboardArrowUp />
                    ) : (
                      <KeyboardArrowDown />
                    )}
                  </IconButton>
                </Grid>
                <Grid item xs={8}>
                  <TableContainer>
                    <Table>
                      <TableHead className={classes.tableHeadContainer}>
                        <TableRow>
                          {createTableCellLabels(serviceCategoryTotalRows)}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow>
                          {createTableCellValues(
                            serviceCategoryTotalRows,
                            serviceCategoriesTotal[key],
                          )}
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </AccordionSummary>
            {accordionShow[key] && (
              <AccordionDetails className={classes.detailsContainer}>
                <TableContainer
                  component={Paper}
                  className={classes.detailsTabContainer}
                >
                  <Table>
                    <TableHead className={classes.tableHeadContainer}>
                      <TableRow>
                        <TableCell />
                        {createTableCellLabels(simulationRows)}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row) => (
                        <Row
                          key={row.name}
                          row={row}
                          isSimulation={isSimulation}
                        />
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            )}
          </Accordion>
        );
      })}
    </Grid>
  );
};

export default DetailTable;
